/* @flow strict */

/* eslint-disable camelcase */

import * as React from 'react';
import CollapsedPanel from '/client/src/components/panel/collapsedPanel';
import SortableList from '/client/src/components/sortableList/container';
import arrayMove from 'array-move';
import DItem from './dItem';
import { defaultDonationsObj } from './defaultDonationsObj';
import { EventDetailContainerContext } from '/client/src/contexts/EventDetailContainer';
import _ from 'lodash';
import { convertToLocalTime } from '/client/src/utils/jstz';

type PropsType = {
  tickets: [],
  donations: null | [],
  isSetAddtionalInfo: boolean,
  handleControlEventDonations: () => void,
  handleControlDonationsEnabled: (string) => void
};

class Donations extends React.Component<PropsType> {
  props: PropsType;
  static contextType = EventDetailContainerContext;

  constructor(props: PropsType) {
    super(props);

    this.state = {
      donations: _.size(props.donations) > 0
      ? props.donations?.sort((a, b): number => a.placement_index - b.placement_index)
      : []
    };
  }

  onSortEnd = ({ oldIndex, newIndex }: any) => {
    const { donations } = this.state;
    const movedDonations = arrayMove(donations, oldIndex, newIndex);
    const sortedDonations = _.map(movedDonations, (d: {}, i: number): {} => {
      return { ...d, placement_index: i + 1 };
    });

    this.setState({
      donations: sortedDonations
    });
    this.props.handleControlEventDonations(sortedDonations);
  };

  handleAddDonationTicket = () => {
    const { donations } = this.props;
    const { eventDetail } = this.context;
    const newItems = [
      ...donations,
      {
        ...defaultDonationsObj,
        id: -1001 - _.size(donations),
        name: `Donation ${_.size(donations) + 1}`,
        temp_id: 1002 + _.size(donations),
        placement_index: _.size(donations) + 1,
        is_required: false,
        isNew: true,
        sale_begin_time_utc: eventDetail ? convertToLocalTime(eventDetail.begin_time_utc, eventDetail.time_zone_id) : Date.now(),
        sale_end_time_utc: eventDetail ? convertToLocalTime(eventDetail.end_time_utc, eventDetail.time_zone_id) : Date.now()
      }
    ];

    this.setState({
      donations: newItems
    }, () => {
      this.props.handleControlEventDonations(_.compact(newItems));
    });
  };

  handleRemove = (index: number, id: string | number) => {
    const { donations } = this.state;

    let newItems = _.clone(donations);

    if (id) {
      newItems = _.filter(donations, (q: {}): {} => {
        if (_.toString(q.id) !== _.toString(id)) {
          return q;
        }
      });
    }

    this.setState({
      donations: _.compact(newItems)
    }, () => {
      this.props.handleControlEventDonations(_.compact(newItems));
    });
  };

  handleSetStatus = (id: string, status: boolean) => {
    const { donations } = this.state;

    const newItems = _.map(donations, (t: {}): {} => {
      if (_.toString(t.id) === _.toString(id)) {
        t.is_active = status;
      }

      return t;
    });

    this.setState({
      tickets: _.compact(newItems)
    }, () => {
      this.props.handleControlEventDonations(_.compact(newItems));
    });
  }

  componentDidUpdate(prevProps: Readonly<P>) {
    if (prevProps.donations !== this.props.donations) {
      this.setState({
        donations: _.size(this.props.donations) > 0
          ? this.props.donations?.sort((a, b): number => a.placement_index - b.placement_index)
          : []
      });
    }
  }

  render(): React.Element<typeof React.Element> {
    const {
      isSetAddtionalInfo,
      tickets,
      handleControlEventDonations
    } = this.props;
    const { donations } = this.state;

    return (
      <CollapsedPanel
        status={isSetAddtionalInfo}
        title='Collect donations'
        onChange={(status: boolean): any => this.props.handleControlDonationsEnabled(status)}
        dataTestid={'Donations'}
      >
        <SortableList
          panelClass={'panel-donation'}
          isClone={false}
          // eslint-disable-next-line
          onSortEnd={this.onSortEnd}
          useDragHandle
          useWindowAsScrollContainer
          disableAutoscroll
          // eslint-disable-next-line
          handleRemoveTicket={this.handleRemove}
          // eslint-disable-next-line
          handleSetStatus={this.handleSetStatus}
          item={DItem}
          type='donations'
          tickets={tickets}
          donations={donations}
          // eslint-disable-next-line
          handleControlEventDonations={handleControlEventDonations}
        />

        <div className="row">
          <div className="col-md-12">
            <button
              className="btn btn-default btn-default-pink btn-lg btn-block btn-text-left"
              type="button"
              onClick={this.handleAddDonationTicket}
              data-testid={'donation-add'}
            >
              <i className="icon icon-plus-square" style={{ marginRight: '1rem' }} />
              <span>Donation</span>
            </button>
          </div>
        </div>
      </CollapsedPanel>
    );
  }
}

export default Donations;
